<template>
  <div>
    <div class="md-data-layer">
      <md-toolbar class="md-transparent" md-elevation="0">
        レイヤー選択
      </md-toolbar>
      <md-list class="md-data-layer-list md-scrollbar">
        <div v-for="(tertiary_item, index) in dataLayer.itemInfo.normal.tertiaryItems"
             v-bind:key="'data-layer-tertiary_item-' + index">
          <md-content class="md-data-layer-info-title">
            <md-radio v-model="form.type" :value="tertiary_item.code">{{ tertiary_item.name }}</md-radio>
            <md-button class="md-icon-button md-raised" @click="clickLayerExpand(tertiary_item.code)">
              <md-icon>{{ form.showLayers[tertiary_item.code].show ? 'expand_less' : 'expand_more' }}</md-icon>
              <md-tooltip md-direction="bottom">{{ tertiary_item.name }}を{{
                  form.showLayers[tertiary_item.code].show ? '閉じる' : '開く'
                }}
              </md-tooltip>
            </md-button>
          </md-content>
          <md-content class="md-data-layer-info-table md-scrollbar">
            <md-table>
              <md-table-row v-show="form.showLayers[tertiary_item.code].show"
                            v-for="(attribute, attrIndex) in coordinateInfoByType(tertiary_item.code)"
                            v-bind:key="'attr-' + index + '-' + attrIndex">
                <md-table-cell v-if="attribute.title" class="coordinate-attribute-title">{{
                    attribute.title
                  }}
                </md-table-cell>
                <md-table-cell v-if="dataLayer.loadingCoordinateInfo" class="coordinate-attribute-content">
                  <md-progress-spinner :md-diameter="15" :md-stroke="2" md-mode="indeterminate"></md-progress-spinner>
                </md-table-cell>
                <md-table-cell v-if="dataLayer.marker" class="coordinate-attribute-content">{{
                    attribute.content
                  }}
                </md-table-cell>
                <md-table-cell class="coordinate-attribute-content" v-else></md-table-cell>
              </md-table-row>
            </md-table>
          </md-content>
        </div>
        <md-subheader>ハザードマップ</md-subheader>
        <md-list-item>
          {{ dataLayer.itemInfo.hazard_map.flood.primaryItem }}
        </md-list-item>
        <md-list-item v-for="(tertiary_item, index) in dataLayer.itemInfo.hazard_map.flood.tertiaryItems"
                      v-bind:key="'data-layer-tertiary_item-' + index" class="md-tertiary-item">
          <div>
            <span class="ruled-line">┗ </span>
            <md-radio v-model="form.type" :value="tertiary_item.code">{{ tertiary_item.name }}</md-radio>
          </div>
        </md-list-item>
        <md-list-item>
          {{ dataLayer.itemInfo.hazard_map.sediment.primaryItem }}
        </md-list-item>
        <md-list-item v-for="(tertiary_item, index) in dataLayer.itemInfo.hazard_map.sediment.tertiaryItems"
                      v-bind:key="'data-layer-tertiary_item-' + index" class="md-tertiary-item">
          <div>
            <span class="ruled-line">┗ </span>
            <md-radio v-model="form.type" :value="tertiary_item.code">{{ tertiary_item.name }}</md-radio>
          </div>
        </md-list-item>
        <!--能登半島地震>>
        -->
        <md-list-item>
          {{ dataLayer.itemInfo.hazard_map.notoEarthquake.primaryItem }}
        </md-list-item>
        <md-list-item v-for="(tertiary_item, index) in dataLayer.itemInfo.hazard_map.notoEarthquake.tertiaryItems"
                      v-bind:key="'data-layer-tertiary_item-' + index" class="md-tertiary-item">
          <div>
            <span class="ruled-line">┗ </span>
            <md-radio v-model="form.type" :value="tertiary_item.code">{{ tertiary_item.name }}</md-radio>
          </div>
        </md-list-item>
        <!--<<能登半島地震-->
        <md-list-item v-for="(tertiary_item, index) in dataLayer.itemInfo.hazard_map.other.tertiaryItems"
                      v-bind:key="'data-layer-tertiary_item-' + index">
          <md-radio v-model="form.type" :value="tertiary_item.code">{{ tertiary_item.name }}</md-radio>
        </md-list-item>
      </md-list>
    </div>
    <md-card class="coordinate-attribute-img"
             v-for="attribute in coordinateInfoByType(form.type)" v-if="attribute.img" :key="attribute.img">
      <md-card-media>
        <img :src="attribute.img" :alt="attribute.alt"/>
      </md-card-media>
      <md-card-content>
        <a :href="attribute.sourceUrl" target="_blank" rel="noopener noreferrer">出典：「ハザードマップポータルサイト」</a>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
import LoadingSpinnerOverlay from "@/components/LoadingSpinnerOverlay";
import CommonMixin           from "@/mixins/commonMixin";
import DataLayer             from "@/modules/map/dataLayer";
import Map                   from "@/modules/map";

export default {
  name      : "MapDataLayerSidebar",
  components: {
    LoadingSpinnerOverlay,
  },
  mixins    : [CommonMixin],
  props     : [],
  data() {
    return {
      form     : {
        type      : null,
        showLayers: {
          kokudo_youto: {
            show: true,
          }
        },
      },
      dataLayer: DataLayer,
    }
  },
  mounted() {
    DataLayer.setZoom();
    DataLayer.setVueDataLayer(this);
  },
  beforeDestroy() {
    this.form.type = null;
    DataLayer.setSelectedDataLayerType(DataLayer.types.naLayer.code);
    DataLayer.setVueDataLayer(null);
    DataLayer.removeMarker();
  },
  computed: {
    dataLayerOptions() {
      return Object.keys(DataLayer.types)
          .filter((type) => {
            return DataLayer.types[type].display === false;
          })
          .map((type) => {
            return DataLayer.types[type];
          });
    },
  },
  watch   : {
    'form.type': function () {
      this.$emit("layer-type", this.form.type);
      DataLayer.setSelectedDataLayerType(this.form.type);
      Map.updateNALayerVisible();
    },
  },
  methods : {
    /**
     * レイヤー情報表示の項目を開閉
     *
     * @param index
     */
    clickLayerExpand(index) {
      this.form.showLayers[index].show = !this.form.showLayers[index].show;
    },
    /**
     * Get coordinate information by type
     */
    coordinateInfoByType(dataLayerType) {
      const filtered = Object.keys(DataLayer.coordinateInfo)
          .filter((type) => {
            return dataLayerType === DataLayer.coordinateInfo[type].code;
          });
      return filtered.length > 0 ? DataLayer.coordinateInfo[filtered[0]].info.toDisplay() : [];
    },
  }
}
</script>

<style lang="scss" scoped>
/*レイヤー選択*/
.md-data-layer {
  .md-data-layer-list {
    -webkit-transform: translate3d(0, 0, 0);
    overflow-y: auto;
  }

  .md-toolbar {
    font-size: 18px;
    margin-top: 8px;
    min-height: 0;
    padding: 0 8px;
  }

  .md-subheader {
    margin-top: 16px;
    padding: 0 8px;
    min-height: 0;
  }

  .md-data-layer-info-title {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 0 8px;

    .md-button {
      position: relative;
      height: 30px;
      width: 30px;
      min-width: 30px;
      margin: 0;
      bottom: -10px;
    }
  }

  .md-list-item-container {
    font-size: 13px;

    ::v-deep(.md-list-item-content) {
      min-height: 29px;
      padding: 0 8px;

      .ruled-line {
        position: relative;
        bottom: 5px;
      }

      .md-radio {
        margin: 0;

        .md-radio-label {
          height: auto;
          white-space: normal;
        }
      }
    }
  }

  .md-table-cell {
    height: 30px;

    &:nth-child(1) {
      min-width: 40%;
      font-size: 11px;
    }

    &:nth-child(2) {
      min-width: 60%;
    }

    &.coordinate-attribute-title {
      width: 110px;
    }
  }

  ::v-deep(.md-table-cell-container) {
    padding: 3px 6px;
  }

  ::v-deep(.md-progress-spinner) {
    margin: 0;
  }
}

/*凡例*/
.coordinate-attribute-img {
  bottom: 40px;
  left: 230px;
  position: absolute;
  z-index: 2;

  .md-card-content {
    padding: 0 5px;
    font-size: 10px;
  }
}
</style>
